const formLock = (status) => {
  /**
   * Блокировка отправки формы при отсутствии программ в регионе
   */
  const form = document.getElementById("form-app");
  if (status == "lock") {
    form.querySelector(".form__checkboxs").style.display = "none";
    form.querySelector("#personal-data").checked = false;
    form.querySelector("#personal-data--pd").checked = false;
    form.querySelector(".form__btn").disabled = true;
  } else {
    form.querySelector(".form__checkboxs").style.display = "block";
    form.querySelector("#personal-data").checked = true;
    form.querySelector("#personal-data--pd").checked = true;
    form.querySelector(".form__btn").disabled = false;
  }
};

export default formLock;
